<template>
  <section class="revenues">
    <div id="fc-container">
      <header>
        <h1>Chiffre d'affaires HT: {{ this.salefiguresTotal | currency }}</h1>
        <ab-button class="primary" @click.native="openModal('stock')"
          >Saisir le stock final</ab-button
        >
      </header>
      <FullCalendar :options="fcOptions" ref="fullCalendarV5"></FullCalendar>
      <!-- SALEFIGURE MODAL -->
      <f-modal class="modal" name="salefigure" height="auto">
        <f-card>
          <form @submit.prevent="handleSalefigure">
            <header>
              <div class="title">{{ modals.salefigure.date | date }}</div>
              <div>
                <ab-icon
                  icon="delete"
                  @click.native="deleteSalefigure"
                ></ab-icon>
                <ab-icon
                  icon="close"
                  @click.native="closeModal('salefigure')"
                ></ab-icon>
              </div>
            </header>
            <main>
              <ab-input
                id="salefigure_total"
                type="number"
                v-model="modals.salefigure.total"
                label="Saisir le chiffre d'affaires"
              ></ab-input>
              <ab-input
                id="salefigure_quantity"
                type="number"
                v-model="modals.salefigure.quantity"
                label="Nombre de couverts"
              ></ab-input>
            </main>
            <footer><ab-button class="primary">Enregistrer</ab-button></footer>
          </form>
        </f-card>
      </f-modal>

      <!-- STOCK MODAL -->
      <f-modal class="modal" name="stock" height="auto">
        <f-card>
          <form @submit.prevent="handleStock">
            <header>
              <div class="title">
                Stock final - {{ this.modals.stock.quantity }}
              </div>
              <div>
                <ab-icon
                  v-if="stocks.length"
                  icon="delete"
                  @click.native="deleteStock"
                ></ab-icon>
                <ab-icon
                  icon="close"
                  @click.native="closeModal('stock')"
                ></ab-icon>
              </div>
            </header>
            <main>
              <ab-input
                type="number"
                id="stock_quantity"
                v-model="modals.stock.quantity"
                label="Saisir le stock final"
              ></ab-input>
            </main>
            <footer><ab-button class="primary">Enregistrer</ab-button></footer>
          </form>
        </f-card>
      </f-modal>
    </div>
  </section>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import AbButton from "@/components/form/button/ab-button.vue";
import AbIcon from "@/components/icon/ab-icon.vue";
import AbIconset from "@/components/icon/ab-iconset.vue";
import AbInput from "@/components/form/input/ab-input.vue";
import DayGridPlugin from "@fullcalendar/daygrid";
import FCard from "../../../components/layout/card/f-card.vue";
import FRLocale from "@fullcalendar/core/locales/fr";
import InteractionPlugin from "@fullcalendar/interaction";
import { mapState } from "vuex";
import messages from "../../../messages/messages.js";

export default {
  name: "Revenues",

  components: {
    AbButton,
    AbInput,
    AbIcon,
    AbIconset,
    FCard,
    FullCalendar,
  },

  data() {
    return {
      fcOptions: {
        height: "auto",
        windowResizeDelay: 300,
        rerenderDelay: 300,
        aspectRatio: 1.35,
        headerToolbar: {
          start: "prev",
          center: "title",
          end: "next",
        },
        titleFormat: {
          year: "numeric",
          month: "long",
        },
        timeFormat: "H(:mm)",
        titleRangeSeparator: " ",
        locales: [FRLocale],
        locale: "fr",
        initialView: "dayGridMonth",
        plugins: [DayGridPlugin, InteractionPlugin],
        dayHeaderFormat: { weekday: "long" },
        dayHeaderClassNames: "ab_fc_th",
        dayCellClassNames: "ab_fc_td",
        events: [],
        selectable: true,
        dateIncrement: { months: 1 },
        dateClick: (e) => {
          !e.dayEl.classList.contains("fc-day-other")
            ? this.openModal("salefigure", e)
            : 0;
        },
        eventClick: (e) => this.openModal("salefigure", e),
      },
      modals: {
        salefigure: {
          date: null,
          _quantity: null,
          price: null,
          _total: null,
          id: null,

          set total(value) {
            this._total = parseInt(value);
          },
          set quantity(value) {
            this._quantity = parseInt(value);
          },
          get total() {
            return !isNaN(this._total) ? this._total : null;
          },
          get quantity() {
            return !isNaN(this._quantity) ? this._quantity : null;
          },
        },
        stock: {
          date: "",
          _quantity: "",
          id: null,

          set quantity(value) {
            this._quantity = parseInt(value);
          },
          get quantity() {
            return this._quantity;
          },
        },
      },
    };
  },

  computed: {
    ...mapState({ clientId: (state) => state.client }),
    ...mapState({ client: (state) => state.clients.client }),
    ...mapState({ salefigures: (state) => state.salefigures.salefigures }),
    ...mapState({ salefigure: (state) => state.salefigures.salefigure }),
    ...mapState({ stocks: (state) => state.stocks.stocks }),
    fcButtons() {
      return [...this.$el.querySelectorAll(".fc-button")];
    },

    fcDisabledDays() {
      return [...this.$el.querySelectorAll(".fc-disabled-day")];
    },

    isStockFetch() {
      return this.stocks && this.stocks.length > 0;
    },

    stockId() {
      return this.isStockFetch ? this.stocks[0].id : null;
    },

    stockDate() {
      return this.isStockFetch ? this.stocks[0].date : null;
    },

    stockQuantity() {
      return this.isStockFetch ? this.stocks[0].quantity : 0;
    },

    salefiguresTotal() {
      if (this.salefigures.length == 1) return this.salefigures[0].total;
      if (this.salefigures.length > 1) {
        const salefigureTotalArray = this.salefigures.map((sf) => sf.total);
        return salefigureTotalArray.reduce((acc, sf) => acc + sf);
      }
      return 0;
    },
  },

  methods: {
    /****************************************
     * FULL CALENDAR
     ****************************************/

    fcParseEvent() {
      if (this.salefigures) {
        this.fcOptions.events = this.salefigures
          .map((salefigure) => {
            return {
              title:
                `CA : ` +
                this.$options.filters.currency(salefigure.total).toString(),
              start: salefigure.date,
              allDay: true,
              classNames: "ab_fc_event_content",
            };
          })
          .concat(
            this.salefigures.map((salefigure) => {
              return {
                title: `Ticket moyen : ${salefigure.price}€`,
                start: salefigure.date,
                allDay: true,
                classNames: "ab_fc_event_average",
              };
            })
          );
      }
    },

    fcCurrentDate() {
      return this.$refs.fullCalendarV5.getApi().view.currentStart;
    },

    fcSalefigureFindIndexByDate(date) {
      return this.fcOptions.events.findIndex((e) => {
        return this.fcDateISOToString(e.start) == date;
      });
    },

    fcDateISOToString(strDate) {
      strDate = new Date(strDate);
      const min10 = (v) => (v > 9 ? v : `0${v}`);
      return [
        strDate.getFullYear(),
        min10(strDate.getMonth() + 1),
        min10(strDate.getDate()),
      ].join("-");
    },

    /****************************************
     * MODALS
     ****************************************/

    openModal(modal, info = null) {
      this.loadModalData(modal, info);
      this.$modal.show(modal);
    },

    closeModal(modal) {
      this.$modal.hide(modal);
    },

    loadModalData(modal, info) {
      this.clearModalData(modal);

      if (modal === "salefigure") {
        this.modals.salefigure.date = info.event
          ? this.fcDateISOToString(info.event.start)
          : info.dateStr;

        const i = this.fcSalefigureFindIndexByDate(this.modals.salefigure.date);
        if (i !== -1) {
          this.modals.salefigure.id = this.salefigures[i].id;
          this.modals.salefigure.total = this.salefigures[i].total;
          this.modals.salefigure.quantity = this.salefigures[i].quantity;
          this.modals.salefigure.price =
            this.modals.salefigure.total / this.modals.salefigure.quantity;
        }
      }

      if (modal === "stock") {
        this.modals.stock.date = this.fcDateISOToString(this.fcCurrentDate());
        this.modals.stock.quantity = this.stockQuantity;
        this.modals.stock.id = this.stockId;
      }
    },

    clearModalData(modal) {
      if (modal === "salefigure") {
        this.modals.salefigure.total = null;
        this.modals.salefigure.quantity = null;
        this.modals.salefigure.price = null;
        this.modals.salefigure.date = null;
        this.modals.salefigure.id = null;
        return;
      }

      if (modal === "stock") {
        this.modals.stock.date = null;
        this.modals.stock.quantity = null;
        this.modals.stock.id = null;
        return;
      }
    },

    clearModalErrors(modal) {
      if (modal === "salefigure") {
        if (this.modals.salefigure.quantityValue > 0)
          this.salefigureInputs().quantity.classList.remove("error");

        if (this.modals.salefigure.totalValue > 0)
          this.salefigureInputs().total.classList.remove("error");
      }

      if (modal === "stock") {
        if (this.stockInputs().quantity.value >= 0)
          this.stockInputs().quantity.classList.remove("error");
      }
    },

    salefigureInputs() {
      return {
        total: this.$el.querySelector("#salefigure_total input"),
        quantity: this.$el.querySelector("#salefigure_quantity input"),
        get quantityValue() {
          return parseInt(this.quantity.value);
        },
        get totalValue() {
          return parseInt(this.total);
        },
      };
    },

    stockInputs() {
      return {
        quantity: this.$el.querySelector("#stock_quantity input"),
        get quantityValue() {
          return parseInt(this.quantity.value);
        },
      };
    },

    /****************************************
     * API
     ****************************************/

    fetchData() {
      const options = {
        clientId: this.$store.getters.getClient,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };
      this.$store.dispatch("getSalefigures", options);
      this.$store.dispatch("getStocks", options);
    },

    /****************************************
     * SALEFIGURE API
     ****************************************/

    handleSalefigure() {
      this.clearModalErrors("salefigure");
      if (
        this.modals.salefigure.total > 0 &&
        this.modals.salefigure.quantity > 0
      ) {
        this.modals.salefigure.price =
          this.modals.salefigure.total / this.modals.salefigure.quantity;

        this.modals.salefigure.id
          ? this.updateSalefigure()
          : this.createSalefigure();
      } else {
        if (this.modals.salefigure.total <= 0) {
          this.salefigureInputs().total.classList.add("error");
          this.displayToast({
            message: messages.selectors.Revenues.custom.number,
            mode: "error",
          });
        }

        if (this.modals.salefigure.quantity <= 0) {
          this.salefigureInputs().quantity.classList.add("error");
          this.displayToast({
            message: messages.selectors.Revenues.custom.number,
            mode: "error",
          });
        }
      }
    },

    async createSalefigure() {
      const newSalefigure = {
        clientId: this.clientId,
        total: this.modals.salefigure.total,
        quantity: this.modals.salefigure.quantity,
        price: this.modals.salefigure.price,
        date: this.modals.salefigure.date,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };
      const response = await this.$store.dispatch(
        "createSalefigure",
        newSalefigure
      );
      if (response.id)
        this.displayToast({
          message: messages.selectors.Revenues.salefigure.creation,
        });

      this.closeModal("salefigure");
    },

    async updateSalefigure() {
      const updateSalefigure = {
        clientId: this.clientId,
        total: this.modals.salefigure.total,
        quantity: this.modals.salefigure.quantity,
        price: this.modals.salefigure.price,
        salefigureId: this.modals.salefigure.id,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };
      const response = await this.$store.dispatch(
        "updateSalefigure",
        updateSalefigure
      );
      if (response.id)
        this.displayToast({
          message: messages.selectors.Revenues.salefigure.edit,
        });

      this.closeModal("salefigure");
    },

    async deleteSalefigure() {
      const deleteSalefigure = {
        clientId: this.clientId,
        salefigureId: this.modals.salefigure.id,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };

      const response = await this.$store.dispatch(
        "deleteSalefigure",
        deleteSalefigure
      );
      if (response)
        this.displayToast({
          message: messages.selectors.Revenues.salefigure.deletion,
        });

      this.closeModal("salefigure");
    },

    /****************************************
     * STOCK API
     ****************************************/

    handleStock() {
      this.clearModalErrors("stock");
      if (this.stockInputs().quantityValue < 0) {
        this.stockInputs().quantity.classList.add("error");
        this.displayToast({
          message: messages.selectors.Revenues.custom.number,
          mode: "error",
        });
      } else {
        this.modals.stock.id = this.stockId;

        const equalMonthAndYear = (a, b) =>
          a.month == b.month && a.year == b.year;
        let date = new Date(this.modals.stock.date);
        const fcDate = {
          month: date.getMonth(),
          year: date.getFullYear(),
        };

        date = new Date(this.stockDate);
        const stockDate = {
          month: date.getMonth(),
          year: date.getFullYear(),
        };

        if (this.stocks.length > 0 && equalMonthAndYear(fcDate, stockDate)) {
          this.updateStock();
        } else {
          this.createStock();
        }
        this.closeModal("stock");
      }
    },

    async createStock() {
      const newStock = {
        clientId: this.clientId,
        date: new Date(this.modals.stock.date).getTime(),
        quantity: this.modals.stock.quantity,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };

      const response = await this.$store.dispatch("createStock", newStock);
      if (response.id)
        this.displayToast({
          message: messages.selectors.Revenues.stock.creation,
        });
    },

    async updateStock() {
      const updateStock = {
        clientId: this.clientId,
        stockId: this.modals.stock.id,
        quantity: this.modals.stock.quantity,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };

      const response = await this.$store.dispatch("updateStock", updateStock);
      if (response.id)
        this.displayToast({ message: messages.selectors.Revenues.stock.edit });
    },

    async deleteStock() {
      const deleteStock = {
        clientId: this.clientId,
        stockId: this.modals.stock.id,
        month: this.fcCurrentDate().getMonth() + 1,
        year: this.fcCurrentDate().getFullYear(),
      };

      const response = await this.$store.dispatch("deleteStock", deleteStock);
      if (response.id)
        this.displayToast({
          message: messages.selectors.Revenues.stock.deletion,
        });

      this.closeModal("stock");
    },
  },

  watch: {
    salefigures() {
      this.fcParseEvent();
    },
  },

  async mounted() {
    if (this.clientId)
      await this.$store.dispatch("getClient", { id: this.clientId });
    this.fetchData();
    this.fcButtons.forEach((button) =>
      button.addEventListener("click", () => this.fetchData())
    );
  },

  updated() {
    const image = "url('/images/icons/add.svg')";
    const getEvents = (el) => {
      const eventContainer = el.querySelector(
        ".fc-daygrid-day-frame > .fc-daygrid-day-events"
      );
      return [...eventContainer.querySelectorAll(".fc-daygrid-event-harness")];
    };

    const nodeDayArrayWithOthers = [...document.querySelectorAll(".ab_fc_td")];
    nodeDayArrayWithOthers.forEach(
      (day) => (day.style.backgroundImage = image)
    );
    const nodeOtherDayArray = [
      ...document.querySelectorAll(".ab_fc_td.fc-day-other"),
    ];
    nodeOtherDayArray.forEach((day) => (day.style.backgroundImage = ""));

    nodeDayArrayWithOthers.forEach((day) => {
      const events = getEvents(day);
      events.length > 0 ? (day.style.backgroundImage = "") : 0;
    });
  },
};
</script>

<style scoped>
/****************************************
  REVENUES
****************************************/
#fc-container {
  background-color: var(--app-white-color);
  box-shadow: var(--app-ctn-shadow);
  border-radius: 5px;
  padding: 1.39rem;
}

.revenues {
  padding: 2.5rem;
}

.revenues header {
  display: flex;
  justify-content: center;
}

.revenues header h1 {
  color: var(--app-secondary-color);
  font-size: 1.4rem;
  font-weight: 600;
}

.revenues header button {
  margin-left: auto;
}

/** MODALS */

.modal section {
  margin: 1rem 0;
}

.modal .title {
  text-transform: uppercase;
  color: var(--app-primary-color);
}

.modal .ab-icon {
  color: var(--app-blue-two);
  cursor: pointer;
}

.modal header {
  justify-content: space-between;
}

/****************************************
  FULL CALENDAR 
****************************************/

>>> .fc {
  margin: 1rem 0;
}

>>> .fc table tbody {
  background-color: var(--app-white-color);
}

/** TOOLBAR */

>>> .fc-header-toolbar {
  display: flex;
  width: 100%;
}

>>> .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {
  width: 100%;
  text-align: center;
  font-size:1.1vw;
}

>>> .fc-header-toolbar .fc-toolbar-title::first-letter {
  text-transform: uppercase;
}

>>> .fc-header-toolbar .fc-button {
  transition: 300ms;
  box-shadow: none !important;
  border:0;
  background-color: var(--app-bg-color);
  color: var(--app-dark-grey);
}

>>> .fc-header-toolbar .fc-button:hover {
  background-color: var(--app-dark-grey);
  color: var(--app-bg-color);
}

/** BORDERS */

>>> .fc-theme-standard .fc-scrollgrid {
  border-top-color: var(--app-light-grey-two);
  border-left-color: var(--app-light-grey-two);
}

>>> .fc-theme-standard th {
  border-right-color: var(--app-light-grey-two);
}

>>> .fc-scrollgrid-section-body > td,
>>> .ab_fc_th,
>>> .ab_fc_td {
  border-bottom-color: var(--app-light-grey-two);
  border-right-color: var(--app-light-grey-two);
}

/** TABLE RESPONSIVITY */

>>> table.fc-col-header,
>>> .fc-daygrid-body,
>>> .fc-daygrid-body table.fc-scrollgrid-sync-table  {
  width: 100% !important;
}

/** THEAD */

>>> .ab_fc_th > div > a::first-letter {
  text-transform: uppercase;
}

>>> .ab_fc_th > div > a {
  color: var(--app-primary-color);
}

/** TBODY */

>>> .ab_fc_td {
  background-repeat: no-repeat;
  background-position: center;
  border-bottom-color: var(--app-light-grey-two);
  border-right-color: var(--app-light-grey-two);
  height: 100%;
}

>>> .ab_fc_td.fc-day-other {
  height: 70px !important;
}

>>> .ab_fc_td:not(.fc-day-other) > div {
  transition: 300ms;
}

>>> .ab_fc_td:not(.fc-day-other):hover > div {
  background-color: var(--app-blue-one);
  opacity: 0.5;
}

>>> .ab_fc_td.fc-day-other .fc-daygrid-day-frame {
  font-size: 0;
  background-color: #109cf110 !important;
}

/** EVENTS */

>>> .fc-event-main {
  white-space: normal;
}

>>> .ab_fc_event_content,
>>> .ab_fc_event_average {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  text-align: center;
}

>>> .ab_fc_event_content *,
>>> .ab_fc_event_average * {
  color: var(--app-primary-color);
}

>>> .ab_fc_event_content * {
  font-size: 12px;
}

>>> .ab_fc_event_average * {
  font-size: 10px;
}
</style>
